/**
 * Deutsches Wörterbuch — Quelle der Wahrheit für die Key-Struktur.
 * en.ts ist typgebunden an dieses Objekt (Dict), fehlende Keys fallen im
 * Build auf. Platzhalter-Format: {name}.
 */
export const de = {
    app: {
        title: 'Optimus Time — Zeiterfassung',
    },
    landing: {
        hero_title: 'Zeiterfassung, die mithält',
        hero_subtitle:
            'Erfasse jede Stunde, stelle korrekt in Rechnung und sieh, wohin deine Zeit wirklich fließt — für dich und dein ganzes Team.',
        beta_banner:
            'Optimus Time befindet sich im Beta-Betrieb und ist noch nicht für den produktiven Einsatz gedacht. Funktionen können sich noch ändern — verlasse dich für abrechnungsrelevante Zeiten bitte nicht allein auf diese Plattform.',
        cta_sign_up: 'Kostenlos starten',
        cta_sign_in: 'Anmelden',
        feature_timer_title: 'Timer mit einem Klick',
        feature_timer_text:
            'Starten, stoppen und bearbeiten in Sekunden — am Schreibtisch und unterwegs.',
        feature_reports_title: 'Berichte & CSV-Export',
        feature_reports_text:
            'Gruppiere nach Projekt, Kunde, Mitglied oder Tag und exportiere alles als CSV.',
        feature_teams_title: 'Workspaces & Teams',
        feature_teams_text:
            'Lade Kolleg:innen ein, vergebe Rollen und halte Kunden und Projekte organisiert.',
        feature_billing_title: 'Verrechenbare Stunden',
        feature_billing_text:
            'Markiere Einträge als verrechenbar, lege Stundensätze fest und behalte deine Erlöse im Blick.',
    },
    common: {
        save: 'Speichern',
        cancel: 'Abbrechen',
        close: 'Schließen',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        create: 'Anlegen',
        all: 'Alle',
        loading: 'Lädt',
        back: '← Zurück',
        next: 'Weiter →',
        exportFailed: 'Export fehlgeschlagen',
        openMenu: 'Menü öffnen',
        closeMenu: 'Menü schließen',
        beta: 'Beta',
        hour: 'Stunde',
        minute: 'Minute',
        pleaseConfirm: 'Bitte bestätigen',
        confirm: 'Bestätigen',
    },
    nav: {
        tracking: 'Zeiterfassung',
        billing: 'Abrechnung',
        entries: 'Einträge',
        reports: 'Berichte',
        invoices: 'Rechnungen',
        monthly: 'Monatsstunden',
        workspace: 'Workspace',
        settings: 'Einstellungen',
        admin: 'Admin',
        logout: 'Abmelden',
        mainNav: 'Hauptnavigation',
        userMenu: 'Benutzermenü öffnen',
        workspaceSwitch: 'Workspace wechseln',
        language: 'Sprache',
        feedback: 'Feedback geben',
    },
    timer: {
        stop: 'Timer stoppen',
        stopped: 'Timer gestoppt',
        started: 'Timer gestartet: {type}',
        switched: 'Wechsel zu {type}',
        ready: 'Timer bereit',
        runningSince: '{type} läuft seit {time}',
        stopType: '{type} stoppen',
        switchTo: 'Zu {type} wechseln',
        startType: '{type} starten',
        goToTracking: 'Zur Zeiterfassung',
    },
    entryType: {
        work: 'Arbeit',
        break: 'Pause',
        meeting: 'Meeting',
        admin: 'Admin',
        sick: 'Krank',
        vacation: 'Urlaub',
        timeOff: 'Zeitausgleich',
        paidAbsence: 'Bezahlte Abw.',
    },
    invoiceStatus: {
        draft: 'Entwurf',
        sent: 'Gesendet',
        paid: 'Bezahlt',
        cancelled: 'Storniert',
    },
    track: {
        today: 'Heute',
        thisWeek: 'Diese Woche',
        summaryLine: '{billable} abrechenbar · {money} · {count} Einträge',
        manualTitle: 'Zeitraum manuell erfassen',
        hide: 'Ausblenden',
        add: '+ Hinzufügen',
        descriptionPlaceholder: 'Woran arbeitest du?',
        manualDescriptionPlaceholder: 'Kurze Beschreibung der Tätigkeit',
        projectClient: 'Projekt / Kunde',
        type: 'Typ',
        billable: 'Abrechenbar',
        start: 'Beginn',
        end: 'Ende',
        endBeforeStart: 'Das Ende darf nicht vor dem Start liegen.',
        entrySaved: 'Eintrag gespeichert',
        saveEntry: 'Eintrag speichern',
        description: 'Beschreibung',
    },
    projectSelect: {
        label: 'Projekt / Kunde',
        withoutAssignment: '— ohne Zuordnung —',
        withoutProject: '{name} (ohne Projekt)',
    },
    entries: {
        project: 'Projekt',
        client: 'Kunde',
        from: 'Von',
        to: 'Bis',
        csvExport: '↓ CSV-Export',
        csvName: 'zeitrapport.csv',
        emptyTitle: 'Keine Zeiteinträge',
        emptyDesc:
            'Passe die Filter an oder erfasse Zeiten auf der Zeiterfassungs-Seite.',
        date: 'Datum',
        duration: 'Dauer',
        yield: 'Ertrag',
        running: 'läuft',
        open: 'offen',
        actions: 'Aktionen',
        pageInfo: 'Seite {page} von {totalPages} · {count} Einträge',
        editTitle: 'Zeiteintrag bearbeiten',
        createTitle: 'Zeiteintrag erfassen',
        deleteConfirm: 'Diesen Zeiteintrag wirklich löschen?',
        entryDeleted: 'Eintrag gelöscht',
        entryUpdated: 'Eintrag aktualisiert',
        endRunningHint: 'Ende (leer = läuft)',
    },
    reports: {
        period: 'Zeitraum',
        presetWeek: 'Diese Woche',
        presetMonth: 'Dieser Monat',
        presetYear: 'Dieses Jahr',
        presetAll: 'Alles',
        presetCustom: 'Zeitraum',
        groupBy: 'Gruppieren nach',
        groupProject: 'Projekt',
        groupClient: 'Kunde',
        groupUser: 'Person',
        groupDay: 'Tag',
        total: 'Gesamt',
        billable: 'Abrechenbar',
        earnings: 'Ertrag',
        entriesLabel: 'Einträge',
        runningOne:
            'Ein Timer läuft aktuell und fließt in die Auswertung mit.',
        runningMany:
            '{count} Timer laufen aktuell und fließen in die Auswertung mit.',
        note: 'Hinweis',
        groupingTitle: 'Gruppierung: {group}',
        loadErrorTitle: 'Bericht konnte nicht geladen werden',
        loadErrorDesc: 'Bitte später erneut versuchen.',
        emptyTitle: 'Keine Daten im Zeitraum',
        emptyDesc: 'Passe Zeitraum oder Filter an.',
        time: 'Zeit',
        csvPrefix: 'bericht',
        noGroup: '— ohne Zuordnung —',
    },
    clients: {
        newClient: '+ Kunde anlegen',
        emptyTitle: 'Noch keine Kunden',
        emptyDesc:
            'Lege deinen ersten Kunden an, um Projekte und abrechenbare Stunden zu verwalten.',
        deleteConfirm:
            'Kunde „{name}“ wirklich löschen? Zugeordnete Projekte bleiben bestehen.',
        deleted: 'Kunde gelöscht',
        projectsCount: 'Projekte ({count})',
        newProject: '+ Projekt',
        noProjects: 'Noch keine Projekte für diesen Kunden.',
        editProjectTooltip: 'Projekt bearbeiten',
        noRate: 'ohne Satz',
        name: 'Name',
        contactDetails: 'Kontaktdaten',
        contactPlaceholder: 'E-Mail, Telefon, Ansprechpartner …',
        notes: 'Notizen',
        invoiceAddress: 'Rechnungsadresse',
        addressPlaceholder: 'Straße, PLZ, Ort, Land',
        vatLabel: 'UID-Nummer (optional)',
        vatPlaceholder: 'ATU…',
        createTitle: 'Kunden anlegen',
        editTitle: 'Kunden bearbeiten',
        created: 'Kunde angelegt',
        saved: 'Kunde gespeichert',
        invalidRate: 'Ungültiger Stundensatz.',
        projectFor: 'Projekt für {name}',
        editProjectTitle: 'Projekt bearbeiten',
        hourlyRateLabel: 'Stundensatz (€, leer = ohne)',
        ratePlaceholder: 'z. B. 65',
        projectCreated: 'Projekt angelegt',
        projectSaved: 'Projekt gespeichert',
        projectDeleted: 'Projekt gelöscht',
        projectDeleteConfirm: 'Projekt „{name}“ wirklich löschen?',
    },
    invoices: {
        title: 'Rechnungen',
        new: '+ Rechnung erstellen',
        emptyTitle: 'Keine Rechnungen',
        emptyDesc:
            'Erstelle eine Rechnung aus deinen unbezahlten, abrechenbaren Stunden.',
        number: 'Nummer',
        client: 'Kunde',
        issueDate: 'Rechnungsdatum',
        status: 'Status',
        sum: 'Summe',
        pdf: 'PDF',
        pdfName: 'Rechnung_{number}.pdf',
        pdfFailed: 'PDF konnte nicht geladen werden',
        pageInfo: 'Seite {page} von {totalPages} · {count} Rechnungen',
        detailTitle: 'Rechnung {number}',
        due: 'Fällig',
        servicePeriod: 'Leistungszeitraum',
        taxRate: 'Steuersatz',
        position: 'Position',
        hours: 'Stunden',
        rate: 'Satz',
        amount: 'Betrag',
        net: 'Netto',
        vat: 'USt ({rate} %)',
        gross: 'Brutto',
        downloadPdf: '↓ PDF herunterladen',
        markSent: 'Als gesendet markieren',
        markPaid: 'Als bezahlt markieren',
        cancelInvoice: 'Stornieren',
        setStatusConfirm: 'Rechnung auf „{label}“ setzen?',
        statusChanged: 'Status geändert: {label}',
        updated: 'Rechnung aktualisiert',
        editTitle: '{number} bearbeiten',
        dueOptional: 'Fällig am (optional)',
        vatPct: 'USt %',
        noteOptional: 'Notiz (optional)',
        notePlaceholder: 'z. B. Zahlungsbedingung',
        draftHint:
            'Nur Entwürfe sind bearbeitbar. USt-Betrag und Summe werden automatisch neu berechnet.',
        createTitle: 'Rechnung erstellen',
        createSuccess: 'Rechnung {number} wurde erstellt',
        createSuccessDesc:
            'Die abrechenbaren Stunden sind jetzt dieser Rechnung zugeordnet.',
        chooseClient: '— Kunde wählen —',
        serviceFrom: 'Leistungszeitraum von (optional)',
        serviceTo: 'Leistungszeitraum bis (optional)',
        unbilled: 'Unbezahlte Stunden',
        unbilledFrom: 'ab {date}',
        unbilledUntil: 'bis {date}',
        loadingPreview: 'Lade Vorschau …',
        noProject: 'Ohne Projekt',
        netEntries: 'Netto ({count} Einträge)',
        skippedWithoutRate:
            '{count} abrechenbare Einträge ohne Stundensatz werden nicht abgerechnet.',
        noUnbilled: 'Keine offenen abrechenbaren Stunden für diesen Kunden.',
        create: 'Rechnung erstellen',
    },
    billing: {
        title: 'Abrechnung',
        subtitle: 'Zeiteinträge, Berichte und Rechnungen deiner Arbeit.',
    },
    workingTime: {
        prevMonth: 'Vorheriger Monat',
        nextMonth: 'Nächster Monat',
        member: 'Mitglied',
        statusOpen: 'Offen',
        statusClosed: 'Abgeschlossen',
        csvExport: 'CSV',
        csvName: 'monatsstunden',
        loadErrorTitle: 'Arbeitszeit konnte nicht geladen werden',
        setupTitle: 'Arbeitszeit-Setup',
        setupDescription:
            'Starttermin, Kernarbeitszeit-Fenster, Wochenarbeitszeit und Urlaubstage pro Jahr sind Pflicht, bevor die Monatstabelle berechnet werden kann.',
        setupStart: 'Starttermin',
        setupCoreFrom: 'Kernarbeitszeit von',
        setupCoreTo: 'Kernarbeitszeit bis',
        setupWeeklyHours: 'Wochenarbeitszeit (Soll, Stunden)',
        setupVacationDays: 'Urlaubstage pro Jahr',
        setupIncomplete: 'Bitte alle Pflichtfelder ausfüllen',
        setupCoreTimeInvalid:
            'Kernarbeitszeit-Fenster ungültig: „von“ muss vor „bis“ liegen',
        setupSaved: 'Arbeitszeit-Setup gespeichert',
        setupWeeklyHoursShort: 'Soll h/Woche',
        setupVacationDaysShort: 'Urlaub/Jahr',
        contractSaved: 'Vertragsdaten gespeichert',
        autoBreakLabel: 'Automatische Mittagspause',
        autoBreakHint: 'Ab 6 h erfasster Dienstzeit werden 0,5 h abgezogen (nur Auswertung).',
        overtimeCarryLabel: 'Überstunden-Vortrag (h)',
        vacationCarryLabel: 'Resturlaub-Vortrag (Tage)',
        carryHint: 'Vorträge wirken auf die Jahreskonten (manuelles Übertragungsmodell).',
        sundayHolidayLabel: 'Sonntag = Default-Feiertag',
        holidayFactorSettingsLabel: 'Feiertags-Faktor',
        tiersTitle: 'Überstunden-Staffel',
        tiersHint:
            'Faktor ab Tagesstunde — z. B. „ab 8 → 1,0" und „ab 10 → 1,5". Stunden unterhalb der ersten Stufe zählen × 1.',
        tierFrom: 'Ab Stunde',
        tierFactor: 'Faktor',
        tierAdd: '+ Stufe',
        absenceTitle: 'Abwesenheit eintragen',
        absenceType: 'Typ',
        absenceDate: 'Datum',
        absenceFullDay: 'Ganztägig',
        absenceFullDayHint: 'Trägt das Tages-Soll ({hours} h) ein.',
        absenceFullDayNoSetup:
            'Ganztägig erst nach Arbeitszeit-Setup (Wochen-Soll unbekannt).',
        absenceHalfDay: 'Halber Tag',
        absenceHalfDayHint:
            'Trägt das halbe Tages-Soll ({hours} h) ein — verbraucht einen halben Urlaubstag.',
        absenceHalfDayPlainHint:
            'Trägt das halbe Tages-Soll ({hours} h) ein.',
        absenceSickHint:
            'Krank wird halb oder ganz getragen und deckt das Tages-Soll wie Urlaub.',
        absenceVacationHint:
            'Urlaub wird ausschließlich halb oder ganz verbraucht; Arbeit füllt das Soll zuerst.',
        absencePaidHint:
            'Bezahlte Abwesenheit (z. B. Arzt-, Amtsbesuch) zählt zur Ist-Zeit — stundenweise.',
        absenceFrom: 'Von',
        absenceTo: 'Bis',
        absenceTimeInvalid: '„Bis" muss nach „Von" liegen',
        absenceRemaining: 'Noch buchbar bis zum Tages-Soll: {hours}',
        absenceExceedsTarget:
            'Damit würde das Ist das Soll überschreiten — maximal noch {hours} buchbar.',
        absenceExisting: 'Bestehende Abwesenheiten an diesem Tag',
        absenceDeleted: 'Abwesenheit gelöscht',
        absenceSave: 'Eintragen',
        absenceSaved: 'Abwesenheit eingetragen',
        absenceHint:
            'Nie abrechenbar. Arbeit füllt das Soll zuerst — Abwesenheit deckt nur die Restlücke.',
        absenceRecord: '{type} eintragen',
        absenceAdd: 'Abwesenheit eintragen',
        addWork: 'Arbeit erfassen',
        showDayEntries: 'Einträge des Tages anzeigen',
        hideDayEntries: 'Einträge des Tages ausblenden',
        holidayMarked: 'Als Feiertag markiert',
        holidaySaved: 'Feiertag gespeichert',
        holidayRemoved: 'Feiertagsmarkierung entfernt',
        holidayEdit: 'Feiertag bearbeiten',
        holidayMark: 'Als Feiertag markieren',
        holidayFactorLabel: 'Faktor (leer = Default {default})',
        holidayNoteLabel: 'Notiz (optional)',
        holidayRemove: 'Markierung entfernen',
        importMonth: 'Monat übernehmen',
        importedMonth: 'Monatsstand übernommen',
        importWeek: 'Übernehmen',
        importedWeek: 'Wochenstand übernommen',
        colActions: 'Aktionen',
        colNight: 'davon Nacht',
        nightFromLabel: 'Nacht-Fenster von',
        nightToLabel: 'Nacht-Fenster bis',
        nightFactorLabel: 'Nacht-Faktor',
        nightHint:
            'Einträge werden in der Auswertung am Fensterrand geteilt; der Faktor wirkt auf gutschreibende Nachtstunden.',
        closeMonth: 'Monat abschließen',
        closeConfirm:
            'Monat {month} abschließen? Die Tageszeilen werden eingefroren (Snapshot) und der PDF-Beleg entsteht daraus.',
        closedToast: 'Monat abgeschlossen',
        reopenMonth: 'Entsperren',
        reopenConfirm:
            'Monat {month} entsperren? Der Snapshot wird gelöscht und live neu berechnet — ein neuer Abschluss erfordert eine neue Unterschrift.',
        reopenedToast: 'Monat entsperrt — Live-Berechnung aktiv',
        closedInfo:
            'Abgeschlossen am {date} — Zeilen eingefroren aus dem Snapshot; Änderungen nur über „Entsperren“.',
        pdfExport: 'PDF-Beleg',
        pdfName: 'monatsbeleg',
        kpiVacation: 'Rest-Urlaub (Jahr)',
        kpiVacationHint: 'Anspruch {entitlement} − verbraucht {used}',
        kpiOvertime: 'Überstundenguthaben',
        kpiOvertimeHint: 'Gutschrift {credit} h − Zeitausgleich {used} h',
        kpiMonthSaldo: 'Monatssaldo',
        kpiMonthSaldoHint: 'Soll {target} · Ist {worked}',
        weekLabel: 'KW',
        weekSum: 'Woche',
        monthTotal: 'Monatssumme',
        colDate: 'Tag',
        colTarget: 'Soll',
        colWorked: 'Ist',
        colBreak: 'Pause',
        colAbsence: 'Abwesend',
        colSaldo: 'Saldo',
        holiday: 'Feiertag',
        absenceSickShort: 'K',
        absenceVacationShort: 'U',
        absenceTimeOffShort: 'ZA',
    },
    workspace: {
        title: 'Workspace',
        subtitle: 'Kunden, Projekte, Mitglieder und Adressen verwalten.',
        tabClients: 'Kunden',
        tabGeneral: 'Allgemein',
        tabMembers: 'Mitglieder',
        tabAddresses: 'Adressen',
        billingData: 'Rechnungsdaten',
        wsName: 'Workspace-Name',
        vatLabel: 'UID-Nummer (§ 11 UStG, optional)',
        vatPlaceholder: 'z. B. ATU12345678',
        vatHint: 'Die UID-Nummer erscheint im Rechnungs-PDF.',
        updated: 'Workspace aktualisiert',
        workingTimeTitle: 'Arbeitszeit-Einstellungen',
        workingTimeWorkdays: 'Arbeitstage',
        workingTimeWorkdaysHint:
            'Tage, an denen das Wochen-Soll gilt (Tages-Soll = Wochen-Soll ÷ Arbeitstage).',
        workingTimeSaved: 'Arbeitszeit-Einstellungen gespeichert',
        contract: 'Arbeitszeit',
        members: 'Mitglieder',
        noMembers: 'Keine Mitglieder',
        name: 'Name',
        email: 'E-Mail',
        role: 'Rolle',
        rateLabel: 'Stundensatz (€/h)',
        you: '(du)',
        leave: 'Verlassen',
        remove: 'Entfernen',
        leaveConfirm: 'Diesen Workspace wirklich verlassen?',
        removeConfirm: '{name} aus dem Workspace entfernen?',
        leftToast: 'Workspace verlassen',
        removedToast: '{name} entfernt',
        promoteConfirm: '{name} zum Owner befördern?',
        promote: 'Befördern',
        roleChanged: 'Rolle von {name}: {role}',
        rateSaved: 'Stundensatz gespeichert',
        inviteTitle: 'Mitglied einladen',
        roleMember: 'Mitglied',
        roleAdmin: 'Admin',
        invite: 'Einladen',
        inviteHint:
            'Unbekannte E-Mail-Adressen erhalten eine Einladung per Mail (7 Tage gültig).',
        inviteEmailPlaceholder: 'kollege@firma.at',
        addedDirect: '{email} wurde direkt hinzugefügt.',
        inviteSent: 'Einladung an {email} versendet (7 Tage gültig).',
        openInvites: 'Offene Einladungen',
        noInvites: 'Keine offenen Einladungen',
        noInvitesDesc:
            'Versendete Einladungen erscheinen hier bis sie angenommen, abgelaufen oder widerrufen sind.',
        validUntil: 'Gültig bis',
        invitedBy: 'Eingeladen von',
        revoke: 'Widerrufen',
        revokeConfirm: 'Einladung an {email} widerrufen?',
        revoked: 'Einladung widerrufen',
        roles: {
            owner: 'Owner',
            admin: 'Admin',
            member: 'Mitglied',
        },
        addressesInfoBadge: 'Info',
        addressesInfo:
            'Die Standard-Adresse erscheint als Absender im Rechnungs-PDF.',
        addresses: 'Adressen',
        newAddress: '+ Adresse anlegen',
        noAddresses: 'Noch keine Adressen',
        noAddressesManage:
            'Lege eine Adresse an, die als Absender im Rechnungs-PDF dient.',
        noAddressesNoManage: 'Nur Owner und Admin können Adressen anlegen.',
        addressCol: 'Adresse',
        countryCol: 'Land',
        defaultBadge: 'Standard',
        addressDeleteConfirm:
            'Adresse {street} {number}, {zip} {city} löschen?',
        addressDeleted: 'Adresse gelöscht',
        addressCreated: 'Adresse angelegt',
        addressUpdated: 'Adresse aktualisiert',
        createAddressTitle: 'Adresse anlegen',
        editAddressTitle: 'Adresse bearbeiten',
        street: 'Straße',
        streetNumber: 'Hausnummer',
        additionalInfo: 'Zusatz (optional)',
        additionalInfoPlaceholder: 'Stock, Tür, …',
        postalCode: 'PLZ',
        city: 'Ort',
        country: 'Land',
        countryDefault: 'Österreich',
        setDefault:
            'Als Standard-Adresse festlegen (ersetzt die bisherige)',
        dangerTitle: 'Workspace löschen',
        dangerDesc:
            'Der Workspace wird mitsamt aller Daten unwiderruflich gelöscht: Mitglieder, Kunden & Projekte, Zeiteinträge, Rechnungen, Adressen und Arbeitszeit-Daten. Das kann nicht rückgängig gemacht werden.',
        nameConfirmLabel: 'Zur Bestätigung den Workspace-Namen eingeben',
        requestCode: 'Lösch-Code anfordern',
        requestCodeAgain: 'Code erneut senden',
        codeSent:
            'Lösch-Code an {email} versendet (15 Minuten gültig, einmalig verwendbar).',
        codeLabel: 'Lösch-Code (6 Ziffern)',
        codePlaceholder: 'z. B. 418372',
        deleteButton: 'Workspace endgültig löschen',
        deleteConfirm:
            'Workspace „{name}" wirklich endgültig löschen? Alle zugehörigen Daten werden unwiderruflich entfernt.',
        deleted: 'Workspace gelöscht',
    },
    settings: {
        title: 'Einstellungen',
        subtitle: 'Profil, Passwort, E-Mail und Account-Verwaltung.',
        profile: 'Profil',
        name: 'Name',
        language: 'Sprache',
        languageDe: 'Deutsch',
        languageEn: 'English',
        profileSaved: 'Profil gespeichert',
        verifyTitle: 'E-Mail verifizieren',
        verifyDesc:
            'Deine E-Mail-Adresse ist noch nicht bestätigt. Folge dem Link in der Bestätigungsmail.',
        resend: 'Erneut senden',
        resent: 'Bestätigungsmail erneut versendet',
        passwordTitle: 'Passwort ändern',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        newPasswordRepeat: 'Neues Passwort (wiederholen)',
        passwordMismatch: 'Die neuen Passwörter stimmen nicht überein.',
        passwordHint:
            '8–128 Zeichen, Groß- und Kleinbuchstaben, Zahl und Sonderzeichen. Nach dem Ändern wirst du abgemeldet — alle Sitzungen werden ungültig.',
        passwordChanged: 'Passwort geändert — bitte neu anmelden',
        emailTitle: 'E-Mail-Adresse ändern',
        current: 'Aktuell:',
        pendingBadge: 'Ausstehend',
        pendingFor: 'Bestätigung ausstehend für {email}',
        newEmail: 'Neue E-Mail',
        requestChange: 'Änderung anfordern',
        changeSent:
            'Bestätigungsmail an {email} versendet — erst der Link dort schließt den Wechsel ab.',
        dangerTitle: 'Account löschen',
        dangerDesc:
            'Der Account wird mitsamt aller Workspaces, Zeiten und Rechnungen gelöscht. Gib deine E-Mail-Adresse ein, um einen Bestätigungs-Link anzufordern.',
        confirmEmailLabel: 'E-Mail ({email}) bestätigen',
        requestDelete: 'Löschen anfordern',
        deleteRequested:
            'Der Bestätigungs-Link wurde gemailt. Die Löschung wird erst nach Klick auf den Link in der Mail ausgeführt.',
        deleteLinkSent: 'Der Bestätigungs-Link wurde gemailt.',
    },
    admin: {
        title: 'Admin',
        subtitle: 'Plattform-Statistiken, Pageviews und Benutzerverwaltung.',
        unavailable: 'Statistiken nicht verfügbar',
        unavailableDesc: 'Kein Admin-Zugriff oder Backend nicht erreichbar.',
        kpiUsers: 'Users',
        kpiVerified: 'Verifiziert',
        kpiUnverified: 'Unverifiziert',
        kpiWorkspaces: 'Workspaces',
        kpiActive30: 'Aktive 30 T.',
        kpiTracked30: 'Getrackt 30 T.',
        registrationsTitle: 'Registrierungen / Tag (90 Tage)',
        registrationsLabel: 'Registrierungen',
        activeTitle: 'Aktive User / Tag (30 Tage)',
        activeLabel: 'aktive User',
        invoicesByStatus: 'Rechnungen nach Status',
        noInvoices: 'Noch keine Rechnungen vorhanden.',
        pageviewsTitle: 'Pageviews (Top 10, 30 Tage)',
        noPageviews: 'Keine Pageviews',
        path: 'Pfad',
        views: 'Aufrufe',
        usersTitle: 'Benutzer',
        userSearch: 'Name oder E-Mail suchen …',
        noUsers: 'Keine Benutzer gefunden',
        noUsersDesc: 'Passe die Suche an.',
        registered: 'Registriert',
        languageCol: 'Sprache',
        lastActive: 'Zuletzt aktiv',
        workspacesCol: 'Workspaces',
        adminBadge: 'Admin',
        notVerified: 'nicht verifiziert',
        usersOf: '{shown} von {total} Benutzern',
        loadMore: 'Mehr laden',
        // E-Mail-Log (Betreiber)
        emailLogTitle: 'E-Mail-Log',
        emailLogSearch: 'Empfänger oder Betreff suchen …',
        emailFilterAll: 'Alle Status',
        emailTypeAll: 'Alle Arten',
        noEmailLogs: 'Keine E-Mails protokolliert',
        noEmailLogsDesc:
            'Jede gesendete oder fehlgeschlagene E-Mail erscheint hier.',
        emailLogsOf: '{shown} von {total} Einträgen',
        emailColTime: 'Zeit',
        emailColType: 'Art',
        emailColRecipient: 'Empfänger',
        emailColSubject: 'Betreff',
        emailColStatus: 'Status',
        emailStatusSent: 'Gesendet',
        emailStatusFailed: 'Fehlgeschlagen',
        emailTypeVerification: 'Verifizierung',
        emailTypeChange: 'E-Mail-Wechsel',
        emailTypeChangeNotice: 'E-Mail-Wechsel-Info',
        emailTypePasswordReset: 'Passwort-Reset',
        emailTypeDeleteUser: 'Kontolöschung',
        emailTypeDeleteWorkspace: 'Workspace-Löschung',
        emailTypeInvite: 'Workspace-Einladung',
        emailTypeAdded: 'Workspace hinzugefügt',
        emailTypeInvoice: 'Rechnung',
        emailTypeDunning: 'Mahnung',
        emailTypeTest: 'Test-E-Mail',
        emailTypeAdminTemplate: 'Admin-Vorlagenmail',
        emailTypeAdminFree: 'Admin-Freitextmail',
        // Einstellungen (Betreiber)
        settingsTitle: 'Einstellungen',
        settingsUnavailable: 'Einstellungen nicht verfügbar',
        signupRow: 'Öffentliche Registrierung',
        stateEnabled: 'Aktiv',
        stateDisabled: 'Deaktiviert',
        signupDesc:
            'Steuert, ob sich neue Nutzer registrieren können. Bestehende Accounts und der Login bleiben unberührt.',
        activateSignup: 'Aktivieren',
        deactivateSignup: 'Deaktivieren',
        confirmActivate:
            'Registrierung wieder aktivieren? Neue Nutzer können sich anschließend registrieren.',
        confirmDeactivate:
            'Registrierung deaktivieren? Neue Nutzer können sich dann nicht mehr registrieren; bestehende Accounts bleiben unberührt.',
        signupActivated: 'Registrierung aktiviert.',
        signupDeactivated: 'Registrierung deaktiviert.',
        testMailRow: 'Test-E-Mail',
        testMailDesc:
            'Prüft den Mail-Versand über die konfigurierte SMTP-Verbindung.',
        testMailTo: 'Empfänger',
        sendTestMail: 'Test-E-Mail senden',
        testMailSent: 'Test-E-Mail versendet.',
        // E-Mail-Versand (Vorlagen in allen Sprachen + Freitext)
        sendMailTitle: 'E-Mail-Versand',
        sendMailDesc:
            'Jede Mail-Vorlage in Deutsch oder Englisch als Preview mit Beispielwerten versenden — oder eine Mail mit freiem Text und freiem Betreff.',
        sendMailModeTemplate: 'Vorlage',
        sendMailModeFree: 'Freier Text',
        sendMailTemplate: 'Vorlage',
        sendMailLanguage: 'Sprache',
        sendMailTo: 'Empfänger',
        sendMailSubject: 'Betreff',
        sendMailText: 'Nachricht',
        sendMailTextPlaceholder: 'Inhalt der E-Mail …',
        sendMailButton: 'E-Mail senden',
        sendMailSent: 'E-Mail versendet.',
        sendMailNoAttachmentHint:
            'Rechnungs- und Mahnungs-Vorlagen werden ohne PDF-Anhang versendet.',
    },
    feedback: {
        title: 'Feedback geben',
        intro: 'Was können wir besser machen? Deine E-Mail-Adresse und die aktuelle Seite werden automatisch mitgesendet.',
        category: 'Kategorie',
        message: 'Nachricht',
        messagePlaceholder: 'Beschreibe dein Anliegen …',
        currentPage: 'Aktuelle Seite',
        sentAs: 'Gesendet als',
        send: 'Absenden',
        sent: 'Danke! Dein Feedback ist eingegangen.',
        catBug: 'Bug',
        catImprovement: 'Verbesserungsvorschlag',
        catFeatureRequest: 'Feature-Wunsch',
        catOther: 'Sonstige Anfrage',
        statusOpen: 'Offen',
        statusRead: 'Gelesen',
        statusDone: 'Erledigt',
        // Admin-Panel
        adminTitle: 'Feedback',
        filterAll: 'Alle',
        noFeedback: 'Kein Feedback',
        noFeedbackDesc: 'Zu diesem Filter gibt es keine Einträge.',
        colDate: 'Datum',
        colCategory: 'Kategorie',
        colUser: 'Nutzer',
        colMessage: 'Nachricht',
        colPath: 'Seite',
        colStatus: 'Status',
        markRead: 'Gelesen',
        markDone: 'Erledigt',
        reopen: 'Wieder öffnen',
        entriesOf: '{shown} von {total} Einträgen',
        // Detail-Dialog (Admin)
        detailTitle: 'Feedback-Details',
        showFull: 'Klicken, um die vollständige Nachricht anzuzeigen',
    },
    login: {
        signin: 'Anmelden',
        signup: 'Registrieren',
        name: 'Name',
        email: 'E-Mail',
        password: 'Passwort',
        passwordHint:
            'Mindestens 8 Zeichen mit Groß- und Kleinbuchstaben, Zahl und Sonderzeichen. Nach der Registrierung erhältst du eine Bestätigungsmail.',
        forgot: 'Passwort vergessen?',
        createAccount: 'Konto anlegen',
        unexpected: 'Unerwarteter Fehler — ist das Backend erreichbar?',
        signupDisabled: 'Die Registrierung ist derzeit deaktiviert.',
        signupDisabledInvite: ' Diese Einladung kann nicht angenommen werden.',
        inviteHint:
            'Du wurdest eingeladen — registriere dich mit der eingeladenen E-Mail-Adresse, um dem Workspace beizutreten.',
        inviteMismatch:
            'Einladung nicht angenommen: Die E-Mail-Adresse stimmt nicht mit der Einladung überein.',
        betaHint:
            'Optimus Time ist im Beta-Betrieb — noch nicht für den produktiven Einsatz gedacht.',
    },
    reset: {
        title: 'Passwort zurücksetzen',
        sent:
            'Falls das Konto existiert, wurde eine Mail mit dem Rücksetz-Link versendet. Prüfe deinen Posteingang.',
        send: 'Rücksetz-Link senden',
        newTitle: 'Neues Passwort festlegen',
        mismatch: 'Die Passwörter stimmen nicht überein.',
        hint: '8–128 Zeichen, Groß- und Kleinbuchstaben, Zahl und Sonderzeichen.',
        save: 'Passwort speichern',
        savedToast: 'Passwort gesetzt — bitte neu anmelden',
        backToLogin: '← Zurück zur Anmeldung',
    },
    verify: {
        invalidTitle: 'Ungültiger Link',
        noToken: 'Der Verifizierungs-Link enthält kein Token.',
        verifying: 'E-Mail wird verifiziert …',
        successTitle: 'E-Mail-Adresse bestätigt',
        errorTitle: 'Bestätigung fehlgeschlagen',
        errorDesc:
            'Der Link ist ungültig oder bereits verwendet worden. Fordere in den Einstellungen eine neue Mail an.',
        toSettings: 'Zu den Einstellungen',
        toLogin: 'Zur Anmeldung',
    },
    emailChange: {
        invalidTitle: 'Ungültiger Link',
        noToken: 'Dem Link fehlt ein Token.',
        confirming: 'E-Mail-Wechsel wird bestätigt …',
        successTitle: 'E-Mail-Wechsel bestätigt',
        errorTitle: 'Bestätigung fehlgeschlagen',
        errorDesc:
            'Der Link ist ungültig, abgelaufen oder die neue Adresse wird bereits verwendet.',
        toSettings: 'Zu den Einstellungen',
        toLogin: 'Zur Anmeldung',
    },
    deleteAccount: {
        invalidTitle: 'Ungültiger Link',
        noToken: 'Dem Löschen-Link fehlt ein Token.',
        title: 'Account endgültig löschen',
        desc:
            'Diese Aktion löscht den Account mitsamt aller Workspaces, Zeiten und Rechnungen und kann nicht rückgängig gemacht werden. Bestätige mit deiner E-Mail-Adresse.',
        confirmEmail: 'E-Mail bestätigen',
        button: 'Account endgültig löschen',
        deleted: 'Account gelöscht.',
    },
    onboarding: {
        welcome: 'Willkommen bei Optimus Time',
        desc:
            'Lege deinen ersten Workspace an, um Kunden, Projekte und Zeiten zu verwalten.',
        name: 'Workspace-Name',
        placeholder: 'z. B. Freelance',
        created: 'Workspace angelegt',
        createFailed: 'Fehler beim Anlegen',
    },
    charts: {
        barChartAria: 'Balkenchart: {label} pro Tag',
    },
    theme: {
        label: 'Design',
        toLight: 'Zu hellem Design wechseln',
        toDark: 'Zu dunklem Design wechseln',
    },
    errors: {
        unexpected: 'Unerwarteter Fehler',
    },
    footer: {
        tagline: 'Einfache Zeiterfassung für dich und dein Team.',
        betaNote: 'Beta-Betrieb — noch nicht für den produktiven Einsatz gedacht.',
        product: 'Produkt',
        legalTitle: 'Rechtliches',
        impressum: 'Impressum',
        datenschutz: 'Datenschutzerklärung',
        agb: 'AGB',
        home: 'Startseite',
    },
    legal: {
        noteTemplate:
            'Hinweis: Dieser Rechtstext ist eine Platzhalter-Vorlage — er muss vom Betreiber geprüft und ergänzt werden.',
        noteBeta:
            'Zudem befindet sich Optimus Time im Beta-Betrieb; die Nutzung für den produktiven Einsatz ist noch nicht vorgesehen.',
        impressum: {
            title: 'Impressum',
            mediaholderH: 'Medieninhaber und Dienstanbieter (§ 5 ECG, § 25 MedienG)',
            mediaholder: '[TODO: Vor- und Nachname bzw. Firmenname]',
            address:
                '[TODO: Straße und Hausnummer]\n[TODO: Postleitzahl und Ort]\n[TODO: Land]',
            contactH: 'Kontakt',
            emailLabel: 'E-Mail',
            businessH: 'Unternehmensangaben',
            business:
                'Gegenstand des Unternehmens: [TODO: z. B. Softwareentwicklung / Dienstleistungen]',
            vat: 'UID-Nummer: [TODO: falls vorhanden]',
            authority: 'Aufsichtsbehörde: [TODO: falls zutreffend]',
            membership: 'Kammermitgliedschaft: [TODO: falls zutreffend]',
            odrH: 'EU-Streitschlichtung',
            odr: 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr. Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
        },
        datenschutz: {
            title: 'Datenschutzerklärung',
            controllerH: 'Verantwortlicher',
            controller:
                '[TODO: Vor- und Nachname bzw. Firmenname]\n[TODO: Straße und Hausnummer]\n[TODO: Postleitzahl, Ort, Land]',
            controllerContact: 'E-Mail: hallo@optimustime.at',
            dataH: 'Welche Daten verarbeiten wir?',
            dataIntro: 'Bei der Nutzung von Optimus Time verarbeiten wir folgende Daten:',
            dataAccount:
                'Kontodaten: Name, E-Mail-Adresse, Passwort (nur als Hash gespeichert)',
            dataTracking:
                'Zeiterfassungsdaten: Beschreibungen, Projekt- und Kundenzuordnungen, Start- und Endzeiten, Verrechenbar-Markierungen sowie die von dir angelegten Einstellungen',
            dataTechnical:
                'Technische Daten: Protokolldaten und Authentifizierungstokens, die für den Betrieb des Dienstes erforderlich sind',
            cookiesH: 'Cookies und lokale Speicherung',
            cookiesIntro:
                'Diese Website setzt nur technisch notwendige Cookies bzw. lokale Speicherung ein (§ 165 Abs 3 Z 3 TKG 2021). Es gibt keine Analyse-, Werbe- oder sonstigen Tracking-Dienste — deshalb ist keine Cookie-Einwilligung erforderlich.',
            cookiesSession:
                'refresh_token (Cookie, 7 Tage): hält die Anmeldung über das Neuladen der Seite hinaus; httpOnly und damit vor Skriptzugriff geschützt.',
            cookiesLocale:
                'Sprachwahl (lokal im Zustands-Store): merkt sich die zuletzt gewählte Sprache der Benutzeroberfläche.',
            cookiesStorage:
                'Lokale Speicherung (localStorage): Darstellungs-Theme, Entwurf der Timer-Beschreibung. Diese Daten verlassen dein Gerät nicht.',
            cookiesFuture:
                'Sollten künftig einwilligungspflichtige Dienste (z. B. Reichweitenstatistik) eingesetzt werden, holen wir vorher deine Einwilligung ein.',
            reachH: 'Reichweitenmessung',
            reachText:
                'Für interne Statistiken zählen wir Seitenaufrufe in anonymisierter Form: Der Pfad der besuchten Seite und das Datum werden als aggregierter Zähler gespeichert — ohne Cookies, ohne User-IDs und ohne IP-Adressen. Diese Daten sind nicht auf Personen beziehbar; ein Einwilligungsbanner ist deshalb nicht erforderlich (§ 165 Abs 3 TKG 2021).',
            purposeH: 'Zwecke und Rechtsgrundlagen',
            purposeText:
                'Wir verarbeiten deine Daten, um den vertraglichen Dienst bereitzustellen (Art 6 Abs 1 lit b DSGVO), gesetzlichen Pflichten nachzukommen (Art 6 Abs 1 lit c DSGVO) sowie den sicheren Betrieb auf Grundlage unseres berechtigten Interesses zu gewährleisten (Art 6 Abs 1 lit f DSGVO).',
            hostingH: 'Hosting',
            hostingText:
                'Der Dienst wird auf Servern innerhalb der Europäischen Union betrieben. [TODO: Hosting-Anbieter und ggf. Angaben zur Auftragsverarbeitung]',
            emailH: 'E-Mail-Kommunikation',
            emailText:
                'Deine E-Mail-Adresse nutzen wir für die kontobezogene Kommunikation (Registrierung, Verifizierung, Einladungen, Passwort- und E-Mail-Änderungen). Newsletter werden keine versendet.',
            retentionH: 'Speicherdauer und Löschung',
            retentionText:
                'Deine Daten werden gespeichert, solange dein Konto besteht. Mit der Löschung deines Kontos werden deine personenbezogenen Daten gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.',
            rightsH: 'Deine Rechte',
            rightsText:
                'Du hast das Recht auf Auskunft, Berichtigung und Löschung deiner Daten sowie auf Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch (Art 15–21 DSGVO). Weiters hast du das Recht, dich bei der Österreichischen Datenschutzbehörde zu beschweren (www.dsb.gv.at).',
            changesH: 'Änderungen dieser Erklärung',
            changesText:
                'Wir können diese Datenschutzerklärung anpassen, wenn sich der Dienst ändert. Die jeweils aktuelle Version ist auf dieser Seite abrufbar. [TODO: Datum des letzten Updates]',
        },
        agb: {
            title: 'Allgemeine Geschäftsbedingungen',
            s1H: '§ 1 Geltungsbereich',
            s1T: 'Diese Allgemeinen Geschäftsbedingungen regeln die Nutzung des Zeiterfassungsdienstes Optimus Time auf optimustime.at, betrieben von [TODO: Betreibername und -anschrift].',
            s2H: '§ 2 Konto und Registrierung',
            s2T: 'Die Nutzung des Dienstes setzt ein Benutzerkonto mit gültiger E-Mail-Adresse voraus, die verifiziert werden muss. Nutzer müssen volljährig sein oder die Zustimmung eines Erziehungsberechtigten haben. [TODO: falls Mindestalter abweicht]',
            s3H: '§ 3 Pflichten des Nutzers',
            s3T: 'Du bist für die Richtigkeit deiner Angaben und die Geheimhaltung deiner Zugangsdaten verantwortlich. Jede gesetzwidrige Nutzung des Dienstes, insbesondere die Verwendung fremder Daten ohne Berechtigung, ist untersagt.',
            s4H: '§ 4 Verfügbarkeit',
            s4T: 'Der Dienst wird mit der branchenüblichen Sorgfalt betrieben. Eine unterbrechungsfreie Verfügbarkeit wird nicht zugesichert; Wartungsarbeiten können zu vorübergehenden Unterbrechungen führen. [TODO: Verfügbarkeitszusagen, falls vorhanden]',
            s5H: '§ 5 Workspaces und Einladungen',
            s5T: 'Nutzer arbeiten in Workspaces mit unterschiedlichen Rollen (Eigentümer, Admin, Mitglied) zusammen. Wer andere Nutzer einlädt, ist dafür verantwortlich, die eingeladenen E-Mail-Adressen verwenden zu dürfen.',
            s6H: '§ 6 Haftung',
            s6T: 'Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, außer bei Personenschäden oder Ansprüchen nach dem österreichischen Produkthaftungsgesetz. [TODO: Haftungsklauseln prüfen]',
            s7H: '§ 7 Laufzeit und Kündigung',
            s7T: 'Das Konto kann jederzeit gekündigt werden. Die Löschung wird in den Einstellungen über einen per E-Mail zugesandten Bestätigungslink ausgelöst.',
            s8H: '§ 8 Schlussbestimmungen',
            s8T: 'Es gilt österreichisches Recht. Gerichtsstand ist [TODO: Gerichtsstand]. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.',
        },
    },
} as const

/** Widen: aus den Literal-Strings von `de` den allgemeinen Dict-Typ ableiten. */
type Widen<T> = {
    [K in keyof T]: T[K] extends string ? string : Widen<T[K]>
}

export type Dict = Widen<typeof de>
